module.exports = __webpack_public_path__ + "static/media/learn-more.4c67d9e4.png";